import { useTranslation } from "react-i18next";
import AnimatedNumber from "~/components/AnimationNumber";
import "../style.css";
import iso1    from "~/assets/logo/iso.jpg";
import iso2    from "~/assets/logo/iso1.png";
import saokhue from "~/assets/logo/saokhue.png";

const OpacitySection = () => {
  const { t } = useTranslation('home');

  const stats = [
    { label: t('stats.customers'), value: 30, suffix: "+", icon: "👥" },
    { label: t('stats.systems'),   value: 20, suffix: "+", icon: "⚙️" },
    { label: t('stats.projects'),  value: 60, suffix: "+", icon: "📁" },
    { label: t('stats.staff'),     value: 60, suffix: "+", icon: "🧑‍💻" },
  ];

  return (
    <section className="dev-stats-section">
      <div className="dev-stats-inner">

        {/* Giải thưởng & chứng nhận */}
        <div className="dev-section-label-wrapper">
          <span className="dev-section-comment">// giải-thưởng-&amp;-chứng-nhận</span>
        </div>
        <h2 className="dev-section-h2" style={{ marginBottom: 32 }}>{t('stats.awards_title')}</h2>

        <div className="dev-awards-row">
          <div className="dev-award-badge">
            <img src={saokhue} alt="Sao Khuê" className="dev-award-img" />
            <span>Sao Khuê</span>
          </div>
          <div className="dev-award-badge">
            <img src={iso1} alt="ISO 9001:2015" className="dev-award-img" />
            <span>ISO 9001:2015</span>
          </div>
          <div className="dev-award-badge">
            <img src={iso2} alt="ISO 27001" className="dev-award-img" />
            <span>ISO 27001</span>
          </div>
        </div>

        {/* Con số nổi bật */}
        <div className="dev-section-label-wrapper" style={{ marginTop: 56 }}>
          <span className="dev-section-comment">// con-số-nổi-bật</span>
        </div>
        <h2 className="dev-section-h2" style={{ marginBottom: 32 }}>{t('stats.numbers_title')}</h2>
        <div className="dev-stats-grid">
          {stats.map((stat, i) => (
            <div key={i} className="dev-stat-card">
              <div className="dev-stat-icon">{stat.icon}</div>
              <div className="dev-stat-number">
                <AnimatedNumber value={stat.value} />
                <span className="dev-stat-suffix">{stat.suffix}</span>
              </div>
              <div className="dev-stat-label">{stat.label}</div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default OpacitySection;
